<template>
  <div class="main-content">
    <div class="form-content">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="200px"
        class="release-form"
      >
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>小程序发版控制</span>
          </div>
          <el-form-item label="探视预约" prop="release_show_course_booking">
            <el-switch
              v-model="ruleForm.release_show_course_booking"
              active-value="1"
              inactive-value="0"
              active-text="展示"
              inactive-text="隐藏"
            ></el-switch>
            <div class="form-tip">开启后，底部“开始预约”tab 显示探视预约页面；关闭则显示课程报名预约页面。</div>
          </el-form-item>

          <el-form-item label="首页医院横幅" prop="release_show_home_banner">
            <el-switch
              v-model="ruleForm.release_show_home_banner"
              active-value="1"
              inactive-value="0"
              active-text="展示"
              inactive-text="隐藏"
            ></el-switch>
            <div class="form-tip">控制首页“普外科术后监护病区”横幅是否显示。</div>
          </el-form-item>

          <el-form-item label="最新公告" prop="release_show_home_news">
            <el-switch
              v-model="ruleForm.release_show_home_news"
              active-value="1"
              inactive-value="0"
              active-text="展示"
              inactive-text="隐藏"
            ></el-switch>
            <div class="form-tip">控制首页“最新公告”模块是否显示。</div>
          </el-form-item>

        <el-form-item label="科室介绍" prop="release_show_home_dept">
          <el-switch
            v-model="ruleForm.release_show_home_dept"
            active-value="1"
            inactive-value="0"
            active-text="展示"
            inactive-text="隐藏"
          ></el-switch>
          <div class="form-tip">控制首页“科室介绍”模块是否显示。</div>
        </el-form-item>

        <el-form-item label="评论/留言" prop="release_show_comment">
          <el-switch
            v-model="ruleForm.release_show_comment"
            active-value="1"
            inactive-value="0"
            active-text="展示"
            inactive-text="隐藏"
          ></el-switch>
          <div class="form-tip">控制资讯详情页评论入口和“我的”页面用户留言入口是否显示。</div>
        </el-form-item>
      </el-card>

        <el-form-item class="btn-group">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        release_show_course_booking: "1",
        release_show_home_banner: "1",
        release_show_home_news: "1",
        release_show_home_dept: "1",
        release_show_comment: "1"
      }
    };
  },
  created() {
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      this.$http({
        url: "config/release",
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0 && data.data) {
          for (let key in this.ruleForm) {
            if (data.data[key] !== undefined && data.data[key] !== null) {
              this.ruleForm[key] = String(data.data[key]);
            }
          }
        }
      });
    },
    onSubmit() {
      this.$http({
        url: "config/release/save",
        method: "post",
        data: this.ruleForm
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: "保存成功",
            type: "success",
            duration: 1500
          });
        } else {
          this.$message.error(data.msg || "保存失败");
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.release-form {
  max-width: 700px;
  margin: 20px auto;
}
.form-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  margin-top: 8px;
}
.btn-group {
  margin-top: 30px;
  text-align: center;
}
</style>
